<div class="order-total">
    <div class="line">
        <span>{{ 'PAY_AT_TABLE.CHEQUE' | translate }}</span>
        <span>{{ billAmount | currencySpace }}</span>
    </div>

    <div class="line">
        <h5>{{ 'PAY_AT_TABLE.REMAINING' | translate }}</h5>
        <h5>{{ totalRemaining | currencySpace }}</h5>
    </div>
</div>

<div class="order-total">
    @for (it of items; track it.id) {
        <div class="line">
            <span>{{ it.qty }} x {{ it.name }}</span>

            <div class="stepper">
                <button type="button" (click)="decItem.emit(it.id)">
                    <mat-icon>remove</mat-icon>
                </button>
                <span>{{ selectedQty[it.id] ?? 0 }}</span>
                <button type="button" (click)="incItem.emit(it.id)">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    }

</div>
